"use client";

import { type FC, startTransition, useEffect } from "react";
import styled from "styled-components";
import { useTransitionRouter } from "next-view-transitions";
import posthog from "posthog-js";

import { PrimaryButton } from "~/client/components/buttons/PrimaryButton";
import { emailGlobalErrorNotice } from "~/client/services/functions/email";
import { ErrorRegistry } from "~/shared/errors";
import type { ErrorPageProps } from "~/types";

const RSC_GENERIC_MESSAGE = "An error occurred in the Server Components render";

const AppErrorPage: FC<ErrorPageProps> = ({ error, reset }) => {
	const router = useTransitionRouter();

	const handleReset = () => {
		startTransition(() => {
			router.refresh();
			reset();
		});
	};

	useEffect(() => {
		posthog.captureException(error, {
			Cause: error.cause,
			Digest: error.digest,
			Message: error.message,
			Name: error.name,
			"Stack Trace": error.stack,
		});

		// Resolve the promise because errors are returned rather than thrown in Server Functions
		emailGlobalErrorNotice(error).then(error => error && console.error(error));
	}, [error]);

	return (
		<Container>
			<TextContainer>
				<h1>Error - something went wrong!</h1>
				<p>
					{error.message.includes(RSC_GENERIC_MESSAGE) && "code" in error
						? ErrorRegistry[error.code as keyof typeof ErrorRegistry].message
						: "An unexpected error occurred. Please try again."}
				</p>
			</TextContainer>
			<ButtonContainer>
				<PrimaryButton onClick={router.back}>
					Go back to last page
				</PrimaryButton>
				<PrimaryButton onClick={handleReset}>Try again</PrimaryButton>
			</ButtonContainer>
		</Container>
	);
};

export default AppErrorPage;

const Container = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	width: 100%;
`;

const ButtonContainer = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-around;
	padding: 1rem;
	
	> * {
		margin: 0 1rem;
	}
`;

const TextContainer = styled.div`
	
`;
